module.exports = __webpack_public_path__ + "img/result-qr.5bee86f7.jpg";